import $ from 'jquery';
import {deliverySave} from "../queries";
import Popup from "../utilities/Popup";
import {changeObjectKeys} from "../utilities";
import lodash from "lodash";

$('.js-form-personal-delivery-save').on('submit', async function (e) {
    e.preventDefault();
    const serializedAarray = $(this).serializeJSON()
    const $addresses = $('.page-order-form__delivery-items, .page-personal-delivery__items');

    let error = false;
    $('.ui-radio-beauty-item__description > span, .page-personal-delivery-item__address').map(function() {
        if ($(this).html() === serializedAarray['delivery_courier_address'] && serializedAarray['delivery_courier_operation_type']==='add') {
            error= true
        }
    })
    if (error){
        Popup.showContent(
            'Ошибка',
            'Вы уже добавили данный адрес, выберите другой.',
            600,
            true
        );
        return;
    }
    $addresses.html();
    $addresses.toggleClass('page-personal-delivery__items--loading');
    $('.page-personal-delivery-form').css('display', 'none');
    const response = await deliverySave(serializedAarray);
    if (response.status == 'success') {
        $addresses.html(response.component);
        $addresses.toggleClass('page-personal-delivery__items--loading');
    }

    const $form = $('.js-page-order-panel__hidden-delivery-form');
    const params = changeObjectKeys(response.mainAddress, lodash.snakeCase)
    if (response.mainAddress){
        $form.find('input').val(function () {
            if (this.name === 'comment'){
                return params['delivery_courier_comment']['value'];
            }
            return params[this.name]['value'];
        });
    }

    if (response.isError) {
        Popup.showContent(
            'Ошибка',
            response.error,
            600,
            true
        );
        $addresses.toggleClass('page-personal-delivery__items--loading');
    }
});
